{
  "facility": {
    "facilityList": "Liste des installations",
    "facilityActions": "Actions sur les installations",
    "addFacility": "Ajouter une installation",
    "retireFacilities": "Retirer les installations",
    "deleteFacilities": "Supprimer les installations",
    "searchByAddress": "Rechercher par adresse",
    "filterFacilities": "Filtrer les installations",
    "activityStatus": "Statut d'activité",
    "facilityInfo": "Informations sur les installations",
    "chooseProgram": "Choisir...",
    "utility": "Service public de charge finale",
    "assetOverview": "Aperçu des actifs",
    "chooseUtility": "Choisir...",
    "noPrograms": "Aucun programme n'est enregistré pour cette {{regionType}}.",
    "chooseProgramHelp": "Choisissez une {{regionType}} et une première période de déclaration pour voir les programmes.",
    "chooseUtilityHelp": "Choisissez un état pour afficher les services publics disponibles.",
    "noUtilities": "Aucun service public trouvé.",
    "retireFacility": "Retirer l'installation",
    "deleteFacility": "Supprimer l'installation",
    "assetList": "Liste des actifs",
    "retireWarning": "Avertissement : Le retrait de cette installation retirera tous ses équipements, et toutes les données d'utilisation de l'équipement",
    "retireWarningEnd": "seront supprimées.",
    "retireConfirmation1": "Je comprends que le retrait de cette installation retirera également tous ses équipements.",
    "retireConfirmation2Start": "Je comprends que toutes les données d'utilisation de l'équipement",
    "retireConfirmation2End": "seront supprimées.",
    "retireMultipleConfirmation_one": "Je comprends que {{count}} installation sélectionnée sera retirée ainsi que tous ses équipements.",
    "retireMultipleConfirmation_other": "Je comprends que {{count}} installations sélectionnées seront retirées ainsi que tous leurs équipements.",
    "deleteMultipleConfirmation_one": "Je comprends que {{count}} installation sélectionnée sera supprimée définitivement et que cette action est irréversible.",
    "deleteMultipleConfirmation_other": "Je comprends que {{count}} installations sélectionnées seront supprimées définitivement et que cette action est irréversible."
  }
}
